import type { Router } from 'vue-router'
import { useAuthStore } from '@stores/auth.ts'
import { getI18n } from '@/plugins/i18n.ts'

export const setupGuards = (router: Router) => {
  router.beforeEach(async (to, from, next) => {
    const { global } = getI18n()
    document.title = global.t(to.meta?.title as string || to.name?.replace('-', '_') as string)
    const authStore = useAuthStore()
    await authStore.reAuthenticate()
    if (to.meta?.public) {
      if (from.query.redirect) {
        return next(from.query.redirect as string)
      }

      return next()
    }

    if (to.meta.unauthenticated) {
      if (authStore.isAuthenticated) {
        return next({ name: 'root' })
      } else {
        if (from.query.redirect) {
          return next(from.query.redirect as string)
        }

        return next()
      }
    }

    if (to.meta.authenticated && !authStore.isAuthenticated) {
      return next({ name: 'auth', query: { redirect: to.fullPath } })
    }

    if (to.meta.mustBeSubscribed && !authStore.isSubscribed) {
      return next({ name: 'root' })
    }

    if (to.query.redirect) {
      return next(from.query.redirect as string)
    }

    return next()
  })
}
